/* Find your cart: step-by-step quiz with a scored recommendation. */
(function () {
  'use strict';
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  var ORDER = ['shopper', 'pet', 'beach'];

  if (customElements.get('cart-finder')) return;
  customElements.define('cart-finder', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.steps = qsa('[data-finder-step]', this);
      this.form = qs('[data-finder-form]', this);
      this.result = qs('[data-finder-result]', this);
      this.intro = qs('[data-finder-intro]', this);
      this.bar = qs('[data-finder-bar]', this);
      this.back = qs('[data-finder-back]', this);
      this.next = qs('[data-finder-next]', this);
      this.current = 0;
      this.props = {};
      if (!this.steps.length) return;

      this.next.addEventListener('click', function () { self.advance(); });
      this.back.addEventListener('click', function () { self.show(self.current - 1, true); });
      this.addEventListener('change', function (event) {
        if (!event.target.matches('input[type="radio"]')) return;
        var step = event.target.closest('[data-finder-step]');
        qsa('.finder__answer', step).forEach(function (label) {
          label.classList.toggle('is-checked', qs('input', label).checked);
        });
        var error = qs('[data-finder-error]', step);
        if (error) error.hidden = true;
      });
      this.addEventListener('click', function (event) {
        if (event.target.closest('[data-finder-restart]')) self.restart();
        var send = event.target.closest('[data-finder-email-submit]');
        if (send) self.sendEmail(send);
      });
      this.form.addEventListener('submit', function (event) { event.preventDefault(); self.advance(); });
      this.show(0, false);
    }

    show(index, focus) {
      var self = this;
      this.current = Math.max(0, Math.min(this.steps.length - 1, index));
      this.steps.forEach(function (step, i) { step.hidden = i !== self.current; });
      this.back.hidden = this.current === 0;
      var last = this.current === this.steps.length - 1;
      this.next.textContent = last ? this.next.getAttribute('data-finish') : this.next.getAttribute('data-next');
      if (this.bar) this.bar.style.width = Math.round((this.current / this.steps.length) * 100) + '%';
      if (focus) {
        var legend = qs('legend', this.steps[this.current]);
        if (legend) legend.focus();
      }
    }

    advance() {
      var step = this.steps[this.current];
      var checked = qs('input:checked', step);
      if (!checked) {
        var error = qs('[data-finder-error]', step);
        if (error) { error.textContent = this.getAttribute('data-required'); error.hidden = false; }
        var first = qs('input', step);
        if (first) first.focus();
        return;
      }
      if (this.current === this.steps.length - 1) this.finish(); else this.show(this.current + 1, true);
    }

    finish() {
      var self = this;
      var scores = { shopper: 0, pet: 0, beach: 0 };
      var picked = [];
      this.props = {};
      this.steps.forEach(function (step) {
        var input = qs('input:checked', step);
        if (!input) return;
        var result = input.getAttribute('data-result') || 'any';
        var weight = parseInt(step.getAttribute('data-weight'), 10) || 0;
        if (scores.hasOwnProperty(result)) scores[result] += weight;
        picked.push({ result: result, reason: input.getAttribute('data-reason'), accessory: input.getAttribute('data-accessory') });
        var key = step.getAttribute('data-key');
        if (key) self.props[key] = input.value;
      });

      var available = ORDER.filter(function (key) { return !!qs('[data-finder-pick="' + key + '"]', self); });
      if (!available.length) return;
      var winner = available[0];
      available.forEach(function (key) { if (scores[key] > scores[winner]) winner = key; });

      qsa('[data-finder-pick]', this).forEach(function (pick) { pick.hidden = pick.getAttribute('data-finder-pick') !== winner; });
      var pick = qs('[data-finder-pick="' + winner + '"]', this);
      this.props.finder_result = pick.getAttribute('data-title');

      var list = qs('[data-finder-reasons]', pick);
      var why = qs('[data-finder-why]', pick);
      list.innerHTML = '';
      var handles = [];
      picked.forEach(function (item) {
        if (item.result !== winner && item.result !== 'any') return;
        if (item.reason) { var li = document.createElement('li'); li.textContent = item.reason; list.appendChild(li); }
        if (item.accessory) handles.push(item.accessory);
      });
      why.hidden = list.children.length === 0;

      var accessories = qs('[data-finder-accessories]', this);
      if (accessories) {
        var any = false;
        qsa('[data-finder-accessory]', accessories).forEach(function (row) {
          var show = handles.indexOf(row.getAttribute('data-finder-accessory')) !== -1;
          row.hidden = !show;
          if (show) any = true;
        });
        accessories.hidden = !any;
      }

      this.form.hidden = true;
      if (this.intro) this.intro.classList.add('visually-hidden');
      this.result.hidden = false;
      var heading = qs('[data-finder-heading]', this);
      if (heading) heading.focus();
      if (this.scrollIntoView) this.scrollIntoView({ block: 'start' });

      try {
        if (window.klaviyo && window.klaviyo.push) {
          window.klaviyo.push(['identify', this.props]);
          window.klaviyo.push(['track', 'Completed Cart Finder', this.props]);
        }
      } catch (e) { /* tracking is optional */ }
    }

    restart() {
      this.form.reset();
      qsa('.finder__answer', this).forEach(function (label) { label.classList.remove('is-checked'); });
      this.result.hidden = true;
      this.form.hidden = false;
      if (this.intro) this.intro.classList.remove('visually-hidden');
      this.show(0, true);
    }

    sendEmail(button) {
      var S = window.Strolee;
      var wrap = button.closest('[data-finder-email]');
      var input = qs('[data-finder-email-input]', wrap);
      var box = qs('[data-finder-email-message]', wrap);
      var email = (input.value || '').trim();
      if (!S || !S.validEmail(email)) {
        input.setAttribute('aria-invalid', 'true');
        if (S) S.showMessage(box, 'error', window.theme.strings.emailInvalid);
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      button.setAttribute('aria-busy', 'true');
      S.klaviyoSubscribe({ email: email, source: this.getAttribute('data-source'), properties: this.props }).then(function () {
        button.removeAttribute('aria-busy');
        S.showMessage(box, 'success', wrap.getAttribute('data-success'));
      }).catch(function () {
        button.removeAttribute('aria-busy');
        S.showMessage(box, 'error', wrap.getAttribute('data-error'));
      });
    }
  });
})();
